import $ from 'jquery';

$(document).ready(function() {
    $('.js-slide-figure').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
        {
            breakpoint: 1441,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false
            }
        }, 
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false
           }
        }, 
        {
            breakpoint: 768,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false
            }
        }, 
        {
            breakpoint: 420,
                settings: {
                slidesToScroll: 1,
                slidesToShow: true,
                arrows: false,
                dots: false,
                variableWidth:true
            }
        }
        ]
    });
});






// WEBPACK FOOTER //
// ./src/js/pages/index/slide-figure.js